import { c as _c } from "react/compiler-runtime";
import { Button } from '@systemeio/components';
import { PackageIcon } from '@systemeio/icons';
import { CurrencyEnum } from '@systemeio/types';
import { IconTile } from 'shared/components/icon-tile';
import { PhysicalProductId } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/physical-offer-interface';
import { usePhysicalProductSelector } from 'modules/funnels/funnel/components/step-configuration-tab/physical-product-selector/hooks/use-physical-product-selector';
import React, { useEffect } from 'react';
import { Modal } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface Props {
  currency: CurrencyEnum;
  onAdd: (product: PhysicalProductId) => void;
  onClose: () => void;
  opened: boolean;
}
export function AddPhysicalProductModal(t0) {
  const $ = _c(44);
  const {
    currency,
    onAdd,
    opened,
    onClose
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== currency) {
    t1 = {
      currency
    };
    $[0] = currency;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    Select,
    localProduct,
    setLocalProduct
  } = usePhysicalProductSelector(t1);
  let t2;
  let t3;
  if ($[2] !== opened || $[3] !== setLocalProduct) {
    t2 = () => {
      if (!opened) {
        setLocalProduct(null);
      }
    };
    t3 = [opened, setLocalProduct];
    $[2] = opened;
    $[3] = setLocalProduct;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== localProduct || $[7] !== onAdd || $[8] !== onClose) {
    t4 = event => {
      event.preventDefault();
      if (!localProduct) {
        return;
      }
      onAdd(localProduct);
      onClose();
    };
    $[6] = localProduct;
    $[7] = onAdd;
    $[8] = onClose;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleAdd = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconTile size="m" tone="gray"><PackageIcon /></IconTile>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("dashboard.funnel.configuration.offer.physical_product_add");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <span>{t6}</span>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("dashboard.funnel.configuration.offer.physical_product_description");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <span className="text-text-tertiary text-sm font-normal">{t8}</span>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <div className="flex items-center gap-4">{t5}<div className="flex flex-col">{t7}{t9}</div></div>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== handleAdd) {
    t11 = <form onSubmit={handleAdd} />;
    $[22] = handleAdd;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("global.cancel");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== onClose || $[27] !== t12) {
    t13 = <Button type="button" className="tablet:flex-none flex-1" onClick={onClose} variant="secondary" size="md">{t12}</Button>;
    $[26] = onClose;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const t14 = !localProduct;
  let t15;
  if ($[29] !== t) {
    t15 = t("dashboard.funnel.configuration.offer.add_product");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14 || $[32] !== t15) {
    t16 = <Button disabled={t14} className="tablet:flex-none flex-1" type="submit" variant="primary" size="md">{t15}</Button>;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t13 || $[35] !== t16) {
    t17 = <>{t13}{t16}</>;
    $[34] = t13;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== Select || $[38] !== onClose || $[39] !== opened || $[40] !== t10 || $[41] !== t11 || $[42] !== t17) {
    t18 = <Modal opened={opened} onClose={onClose} title={t10} render={t11} footer={t17}>{Select}</Modal>;
    $[37] = Select;
    $[38] = onClose;
    $[39] = opened;
    $[40] = t10;
    $[41] = t11;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}